<template>
    <div class="rating py-1 mr-1">
        <span v-for="index in 5" :key="index">
            <span :class="{'star rating-icon-star': index <= filledStars, 'star': index > filledStars}">
                &#9733;
            </span>
        </span>
    </div>
</template>

<script>
export default {
    name: "Rating",
    props: {
        rating: {
            type: String,
            required: true
        }
    },
    computed: {
        filledStars() {
            // Ensure the rating is a number and round it
            const roundedRating = Math.round(Number(this.rating));  // Convert to a number if it's a string
            // Limit the number of filled stars to a maximum of 5
            return Math.min(roundedRating, 5);  // Compare to the number 5, not the string '5'
        }
    }
}
</script>

<style >
.star {
    color: #ccc;
    background: rgb(255 255 255);
    margin: 1px;
    text-align: center;
    border-radius: 2px;
    padding: 2px;
    display: inline-block;
    line-height: 24px;
    border: 1px solid;
    font-size: 20px;
}

.rating-icon-star {
    color: rgb(255 255 255);
    background: #ff5e1f !important;
    border: 1px solid #ff5e1f !important;
    margin: 1px;
    text-align: center;
    border-radius: 2px;
    padding: 2px;
    display: inline-block;
    line-height: 24px;
    font-size: 20px;
}

.rating {
    display: inline-block;
}
</style>

